import 'dotenv/config';
import * as css from "./PourOut.module.scss";

export function PourOut() {
    const emailAdress = process.env.ENKINDLE_EMAIL_ADDRESS_LINK;
    const headerURL = new URL("../../images/pour-out-header.png", import.meta.url);

    const eventStrip1 = new URL("../../images/event-hd-strips-1.jpg", import.meta.url);
    const eventStrip2 = new URL("../../images/event-hd-strips-2.jpg", import.meta.url);
    
    const groupmeLogo = new URL("../../images/groupme.svg", import.meta.url);
    
    return (
        <>
            <section className={css.groupme}>
                <div className={css.groupmeWrap}>
                    <div className={css.gmPod}>
                        <h2 className="heading">Upcoming Events</h2>
                        <a className={css.gmLink} target="_blank" href="https://groupme.com/join_group/110509635/b5QQqrjq"><img className={css.gmLogo} src={groupmeLogo} alt="Join Our GroupMe" />Join Our GroupMe</a>
                    </div>
                    <div className={css.gmPod}>
                        <p>Do you want to stay informed about future Enkindle events? Join our GroupMe and get notified instantly!</p>
                    </div>
                </div>
            </section> 
            <section className={css.po}>
                <div className={css.poHeaderBox}>
                    <img src={headerURL} alt="Pour Out" />
                </div>

                <div className={css.fullPanel}>
                    <div className={css.panelImage}>
                        <img src={eventStrip1} alt="Female praying" />
                    </div>
                    <div className={css.panelContent}>
                        <div>
                            <h2 className="heading">The Kerygma &amp; Relationship</h2>
                            <p>Since the beginning, God has been pursuing the human heart in deep, personal relationship. While we were enslaved by sin and the devil, God still pursued. And rather than leaving us captured in this state, Jesus came and rescued us, making a way for us to enter Heaven and experience unimaginable happiness with the Trinity for all eternity.</p>
                            {/* <a className={css.registerLink} href='https://forms.gle/bVQbSa1QAzyDTfZG7' target='_blank'>event registration</a> */}
                        </div>
                    </div>
                </div>

                <div className={css.fullPanel}>
                    <div className={`${css.panelContent} ${css.swap}`}>
                        <div>
                            <h2 className="heading">Response of Praise</h2>
                            <p>This is the human story! And what is our response? If we accept God's invitation to relationship, then in love and through worship, we respond by praising Him for who He is and what He has done. Join Christians from all over as we respond to God's pursuit of our hearts in this unique experience of praise through beautiful devotional music. Join us in this experience of prayer that is aimed at a heart-level deepening of one's relationship with God.</p>
                            {/* <a className={css.registerLink} href='https://forms.gle/bVQbSa1QAzyDTfZG7' target='_blank'>event registration</a> */}
                        </div>
                    </div>
                    <div className={css.panelImage}>
                        <img src={eventStrip2} alt="Female praying" />
                    </div>
                </div>

                <div className={css.resources}>
                    <div className={css.pods}>
                        <div className={css.card}>
                            <div className={`${css.cardImg} ${css.imgResource1}`}></div>
                            <div className={css.cardInfo}>
                                <div>
                                    <h2 className="heading eBlueDark">Event Details</h2>
                                    <p>
                                        <span><strong className="eBlue">October 26, 7:30pm</strong></span>
                                        <span>St. Francis of Assisi, Clare Hall</span>
                                        <span>861 N Socora St, Wichita, KS 67212</span><br />
                                        <span>Bring an appetizer or dessert to share in fellowship afterwards!</span>
                                    </p>
                                    {/* <a className={css.resourceRegisterLink} href='https://forms.gle/bVQbSa1QAzyDTfZG7' target='_blank'>register here</a> */}
                                </div>
                            </div>
                        </div>
                        <div className={css.card}>
                            <div className={`${css.cardImg} ${css.imgResource2}`}></div>
                            <div className={css.cardInfo}>
                                <div>
                                    <h2 className="heading eBlueDark">Event Resources</h2>
                                    <ul className={css.resourceUl}>
                                        {/* <li className={css.pdf}><a target='_blank' href='/resources/contact-sheet.pdf'>Contact Sheet</a></li> */}
                                        <li className={css.image}><a target='_blank' href='/resources/digital-flier.jpg'>Digital Flyer</a></li>
                                        {/* <li className={css.image}><a target='_blank' href='/resources/digital-flier-social.jpg'>Digital Flier (Social Media Version)</a></li> */}
                                        {/* <li className={css.image}><a target='_blank' href='/resources/bulletin-image.jpg'>Parish Bulletin (Image)</a></li>
                                        <li className={css.document}><a target='_blank' href='/resources/bulletin-message.txt'>Parish Bulletin (Text)</a></li> */}
                                        {/* <li className={css.image}><a target='_blank' href='/resources/poster.jpg'>Poster (8.5in x 11in)</a></li>
                                        <li className={css.image}><a target='_blank' href='/resources/form-qr-code.png'>Registration QR Code</a></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}